export const OFFSET = [
  { id: '1M', displayValue: '1M' },
  { id: '2M', displayValue: '2M' },
  { id: '3M', displayValue: '3M' },
  { id: '6M', displayValue: '6M' },
  { id: '1Y', displayValue: '1Y' },
  { id: '2Y', displayValue: '2Y' },
  { id: 'TENOR', displayValue: 'Tenor' },
];
